<template>
	<div class="Release">
		<div class="summary_bag">
			<div class="summary_complete_bag">
				<!-- 时间 -->
				<div class="summary_complete">
					<div @click="complete(2)" v-bind:class="{ active: type === 2 }">
						已完成
					</div>
					<!-- ({{ finishedConut }})个 -->
					<div @click="complete(1)" v-bind:class="{ active: type === 1 }" style="margin-left: 10px;">
						未完成
					</div>
					<!-- ({{ unfinishedConut }})个 -->
					<!-- <div
                        @click="complete(3)"
                        v-bind:class="{active: type === 3}"
                        style="margin-left: 10px;"
                    >未完成({{unfinishedConut}})个</div>-->
				</div>
				<el-form :inline="true" label-width="120px" ref="selectForm" :model="selectForm">
					<!-- <div class="summary_Date"> -->
					<el-form-item label="选择分公司" prop="branchCompany" v-if="
						[1].includes(UserInfo.type) &&
						!['客服部', '常规客服部'].includes(
							UserInfo.superDepartmentName
						)
					">
						<el-select v-model="selectForm.branchCompany" placeholder="请选择"
							@change="selectChange($event, 'sonCompany')" value-key="company_id" filterable>
							<el-option v-for="item in branchCompany" :key="item.company_id" :label="item.companyName"
								:value="item"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="选择子公司" prop="sonCompany" v-if="
						[2, 1].includes(UserInfo.type) ||
						(UserInfo.system === 5 &&
							UserInfo.superDepartmentName ===
							'常规客服部')
					">
						<el-select v-model="selectForm.sonCompany" placeholder="请选择" value-key="rid"
							@change="selectChange($event, 'departmentList')" filterable>
							<el-option v-for="item in sonCompany" :key="item.company_id" :label="item.companyName"
								:value="item"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="选择分部门" prop="departmentValue" v-if="
						UserInfo.system < 3 ||
						UserInfo.superDepartmentName === '客服部' ||
						(UserInfo.system === 5 &&
							UserInfo.superDepartmentName ===
							'常规客服部')
					">
						<el-select v-model="selectForm.departmentValue" placeholder="请选择" value-key="rid"
							@change="selectChange($event, 'groupList')">
							<el-option v-for="item in departmentList" :key="item.rid" :label="item.departmentName"
								:value="item"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="选择组" prop="groupValue" v-if="
						UserInfo.system < 4 ||
						UserInfo.superDepartmentName === '客服部' ||
						(UserInfo.system === 5 &&
							UserInfo.superDepartmentName ===
							'常规客服部')
					">
						<el-select v-model="selectForm.groupValue" placeholder="请选择" value-key="rid"
							@change="selectChange($event, 'staffList')">
							<el-option v-for="item in groupList" :key="item.rid" :label="item.groupName"
								:value="item"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="选择员工" prop="staffValue" v-if="
						UserInfo.system < 5 ||
						UserInfo.superDepartmentName === '客服部' ||
						(UserInfo.system === 5 &&
							UserInfo.superDepartmentName ===
							'常规客服部')
					">
						<el-select v-model="selectForm.staffValue" placeholder="请选择" value-key="rid"
							@change="selectChange($event)">
							<el-option v-for="item in staffList" :key="item.rid" :label="item.roleUserName"
								:value="item"></el-option>
						</el-select>
					</el-form-item>
					<!-- </div>
                    <div class="summary_Date"> -->
					<el-form-item label="商品类型" prop="value">
						<el-select @change="selectChanged" v-model="selectForm.value" placeholder="请选择">
							<el-option v-for="(item, index) in options" :key="index" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<!-- <el-form-item prop="startTime" label="开始日期">
                        <el-date-picker
                        v-model="selectForm.startTime"
                        type="datetime"
                        placeholder="选择开始日期"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="pickerOptions"
                        ></el-date-picker>
                    </el-form-item> -->
					<el-form-item label="开始日期" prop="startTime">
						<el-date-picker v-model="selectForm.startTime" align="right" type="datetime"
							placeholder="选择开始日期" value-format="yyyy-MM-dd HH:mm:ss" :picker-options="pickerOptions"
							style="width:200px;"></el-date-picker>
					</el-form-item>
					<el-form-item label="结束日期" prop="endTime">
						<el-date-picker v-model="selectForm.endTime" align="right" type="datetime" placeholder="选择结束日期"
							value-format="yyyy-MM-dd HH:mm:ss" :picker-options="pickerOptions"
							style="width:200px;"></el-date-picker>
						<!-- @change="endDate" -->
					</el-form-item>
					<el-form-item label="上传状态" prop="mark">
						<el-select v-model="selectForm.mark">
							<!-- <el-option label="全部" value=""></el-option> -->
							<el-option label="未上传" value="0"></el-option>
							<el-option label="已上传" value="1"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="翻译状态" prop="isTranslation">
						<el-select v-model="selectForm.isTranslation">
							<!-- <el-option label="全部" value=""></el-option> -->
							<!-- <el-option label=" " value="0"></el-option> -->
							<el-option label="未翻译" :value="1"></el-option>
							<el-option label="翻译中" :value="2"></el-option>
							<el-option label="已翻译" :value="3"></el-option>
						</el-select>
					</el-form-item>
					<!-- </div>
                    <div class="summary_Date"> -->
					<el-form-item label="ID、标题、SKU" prop="input">
						<el-input v-model="selectForm.input" placeholder="ID、标题、SKU"
							style="width:530px;" clearable @input="Change_Inp" @clear="handleClear"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="search">搜索</el-button>
						<el-button type="primary" @click="resetForm('selectForm')">重置</el-button>
					</el-form-item>
					<!-- </div> -->
				</el-form>
			</div>
			<el-card v-show="Newlytype">
				<div class="condition">
					<p>{{ name }}:</p>
					<div class="Choice">
						<span v-for="(item, index) in Newlylist" :key="index" @click="Choice(index)"
							:class="{ activespan: Choicetype === index }">
							{{ item.name }}
						</span>
					</div>
				</div>
			</el-card>
			<!-- 符合查询条件的产品共-->
			<div class="summary_pagenum">
				<div class="summary_query">
					符合查询条件的产品共
					<span>{{ count }}</span>
					件
				</div>
				<!-- <div class="block">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage4"
                        :page-sizes="[20, 50, 100, 200]"
                        layout="total, sizes"
                        :total="count"
                    ></el-pagination>
                </div>-->
			</div>
			<div class="summary_content">
				<div class="summary_batch">
					<span>已选择产品{{ piece }}件</span>
					<template v-if="UserInfo.system === 5">
						<span @click="del" style="cursor:pointer">批量删除</span>
						<span @click="edit" style="cursor:pointer">批量编辑</span>
						<span @click="synchronization(1)" style="cursor:pointer">同步/批量同步</span>
						<span @click="exportData" style="cursor:pointer">导出数据</span>
						<span  style="cursor:pointer" @click="clickElUpload">
							上传Excel
						</span>
						<span v-if="type == 1" style="cursor:pointer" @click="batchCompletion">
							批量完成
						</span>

						<el-upload
							ref="uploader"
							style="display: none;"
							:auto-upload="false"
							action=""
							:on-change="readExcel"
							accept=".xls,.xlsx"
						>
						</el-upload>
					</template>
					<!-- <span @click="translate">批量翻译</span>
                    
                    <span @click="Testing">批量检测</span>-->
				</div>
				<div class="summary_list">
					<!-- 头部 -->
					<el-table ref="multipleTable" :data="summarylist" style="width: 100%" v-loading="load_data"
						element-loading-text="拼命加载中" border @selection-change="on_batch_select"
						:header-cell-style="iscenter" stripe>
						<!-- :cell-style="style" -->
						<el-table-column width="50" type="selection" align="center"></el-table-column>
						<el-table-column width="180" label="产品ID" prop="productNumber" align="center"></el-table-column>
						<el-table-column label="主图" width="100" align="center">
							<template slot-scope="scope">
								<el-popover trigger="hover" placement="right">
									<img :src="scope.row.productImgUrl" class="prduct_img" alt />
									<div class="scope_img" slot="reference">
										<img :src="scope.row.productImgUrl" alt />
									</div>
								</el-popover>
							</template>
						</el-table-column>
						<el-table-column prop="title" label="标题" width="400">
							<template slot-scope="scope">
								<!--                            <el-tooltip class="item" effect="dark" :content="scope.row.title" placement="top">-->
								<div>{{ scope.row.title }}</div>
								<!--                            </el-tooltip>-->
							</template>
						</el-table-column>
						<el-table-column prop="titleDifferentiation" label="标题亮点" width="400"></el-table-column>
						<el-table-column width="160" prop="updateTime" label="更新时间" align="center"></el-table-column>
						<el-table-column width="140" prop="sku" label="父SKU" align="center"></el-table-column>
						<el-table-column width="140" prop="productPrice" label="价格" align="center">
							<template slot-scope="scope">
								<div>{{ itemPrice(scope.row) }}</div>
							</template>
						</el-table-column>
						<el-table-column width="100" prop="productType" label="商品类型" align="center">
							<template slot-scope="scope">
								<div v-if="scope.row.productType === 1">
									新建
								</div>
								<div v-else-if="scope.row.productType === 2">
									认领
								</div>
								<div v-else-if="scope.row.productType === 3">
									孵化
								</div>
								<div v-else-if="scope.row.productType === 4">
									复制
								</div>
								<div v-else-if="scope.row.productType === 5">
									迁移
								</div>
							</template>
						</el-table-column>
						<el-table-column width="100" prop="productType" label="翻译状态" align="center">
							<template slot-scope="scope">
								<div v-if="scope.row.isTranslation === 2" style="color: #E6A23C;">
									翻译中
								</div>
								<div v-else-if="scope.row.isTranslation === 3" style="color: #67C23A;">
									已翻译
								</div>
								<div v-else-if="scope.row.isTranslation === 4" style="color: #F56C6C;">
									翻译超时
								</div>
								<div v-else style="color: #409EFF;">未翻译</div>
							</template>
						</el-table-column>

						<!-- <el-table-column prop="sourceLink" label="来源" width="180"></el-table-column> -->
						<el-table-column width="100" label="来源" align="center">
							<template slot-scope="scope">
								<template v-if="
									scope.row.sourceLinks &&
									scope.row.sourceLinks.length
								">
									<template v-if="scope.row.sourceLinks.length">
										<div v-for="(item, index) in scope.row
											.sourceLinks" :key="item">
											<el-link :href="item" target="_blank" type="primary">
												{{
													'BUY' +
													(scope.row.sourceLinks
														.length > 1
														? index + 1
														: '')
												}}
											</el-link>
										</div>
									</template>
									<template v-else>
										<div>暂无</div>
									</template>
								</template>
								<template v-else>
									<div>暂无</div>
								</template>
							</template>
						</el-table-column>
						<!-- <el-table-column
                            width="200"
                            prop="fenName"
                            label="所属分公司"
                            align="center"
                            v-if="UserInfo.type === 1"
                        ></el-table-column> -->
						<el-table-column width="200" prop="ziName" label="所属公司" align="center"
							v-if="[1, 2].includes(UserInfo.type)">
							<template slot-scope="scope">
								<div>
									<span>{{ scope.row.fenName }}</span>
									<span v-if="
										scope.row.fenName &&
										scope.row.ziName
									">&nbsp;-&nbsp;</span>
									<span>{{ scope.row.ziName }}</span>
								</div>
							</template>
						</el-table-column>
						<el-table-column width="200" prop="userRoleName" label="产品创建人" align="center"></el-table-column>
						<el-table-column label="操作" fixed="right" :width="operateWidth" align="center" width="250">
							<template slot-scope="props">
								<template v-if="
									UserInfo.system === 5 &&
									(UserInfo.superDepartmentName ===
		'运营部' || UserInfo.copyPermissions == '1')
								">
									<el-tooltip class="item" effect="dark" content="编辑" placement="bottom">
										<router-link :to="{
											name: 'editProduct',
											params: {
												id: props.row.id,
												pageType: 'download',
											},
										}" style="display: inline-block;height: 100%;">
											<el-button type="primary" icon="el-icon-edit"></el-button>
										</router-link>
									</el-tooltip>
									<el-tooltip class="item" effect="dark" content="复制" placement="bottom">
										<el-button type="success" icon="el-icon-document-copy"
											style="margin-left: 10px;" @click="copy(props.row.id)"></el-button>
									</el-tooltip>
									<!-- <el-tooltip class="item" effect="dark" content="同步" placement="bottom">
										<el-button type="success" :disabled="props.row.isTranslation != 3 || type == 1"
											icon="el-icon-data-line" style="margin-left: 10px;"
											@click="synchronization(2)"></el-button>
									</el-tooltip> -->
									<!-- <span class="oper" @click="release(props.row.id)">上传</span> -->
									<el-tooltip class="item" effect="dark" content="删除" placement="bottom">
										<el-button type="danger" icon="el-icon-delete" style="margin-left: 10px;"
											@click="removeId(props.row.id)"></el-button>
									</el-tooltip>
								</template>
								<template v-else>
									<el-tooltip class="item" effect="dark" content="查看" placement="bottom">
										<router-link :to="{
											name: 'editProduct',
											params: {
												id: props.row.id,
												pageType: 'download',
											},
										}">
											<el-button type="primary" icon="el-icon-view"></el-button>
										</router-link>
									</el-tooltip>
								</template>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
			<div class="summary_pagenum_block">
				<div class="block">
					<el-pagination @current-change="handleCurrentChange" :current-page="currentPage4"
						@size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100]"
						layout="total, sizes, prev, pager, next, jumper" :total="count"></el-pagination>
				</div>
			</div>
		</div>
		<commodity-frame ref="CommodityFrame" @confirm="commodityFrameConfirm"></commodity-frame>
		<el-dialog title="同步店铺" :visible.sync="synchronizationDialog" width="30%" top="5vh" center
			v-loading="dialogLoding">
			<el-checkbox v-model="isAllSelected" @change="toggleSelectAll(synchronizationList)">
				全选
			</el-checkbox>
			<div v-for="(item, i) in synchronizationList" class="select-css" style="margin-top: 10px;">
				<div class="jc-sb">
					<span>{{ item.countryName }} </span>
				</div>
				<div style="padding: 5px 0 0 0;">
					<el-checkbox-group v-model="radio" v-removeAriaHidden>
						<el-checkbox class="mL-10" :key="index" v-for="(items, index) in item.shopInfos"
							:label="items.shopId">
							{{ items.shopName }}
						</el-checkbox>
					</el-checkbox-group>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="synchronizationDialog = false">取 消</el-button>
				<el-button type="primary" @click="clickSynchronization">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
let isUpdate = false
let isEditFrom = false;
import CommodityFrame from './elasticFrame/commodityFrame.vue'
import EstablishProduct from './EstablishProduct.vue'
import { ajaxPost, Baseurl } from '../../../api/api/api'
import * as XLSX from 'xlsx';
import {exportExcel} from '../../../utils/common.js'
export default {
	name: 'ConmmoditySummary',
	components: {
		CommodityFrame,
		EstablishProduct
	},
	beforeRouteEnter(to, from, next) {
		isEditFrom = from.name == 'editProduct'
		if (from.name == 'editProduct') {
			isUpdate = false
		} else {
			isUpdate = true
		}
		next()
	},
	beforeRouteLeave(to, from, next) {
		// 不管去哪里，始终保持缓存
		this.$store.commit('SET_IS_CACHE_CONMMODITY', true)
		next()
	},
	data() {
		return {
			// 临时选择的产品信息
			selectTemporary: null,
			radio: [],
			synchronizationDialog: false,
			synchronizationList: null,
			isAllSelected: false,
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() > Date.now()
				},
				shortcuts: [
					{
						text: '本月',
						onClick: (picker) => {
							const date = new Date()
							picker.$emit('pick', date)
							this.calculationDate()
						},
					},
					{
						text: '上一月',
						onClick: (picker) => {
							const date = new Date()
							picker.$emit('pick', date)
							this.calculationDate(-1)
						},
					},
					{
						text: '上两月',
						onClick: (picker) => {
							const date = new Date()
							picker.$emit('pick', date)
							this.calculationDate(-2)
						},
					},
					{
						text: '上三月',
						onClick: (picker) => {
							const date = new Date()
							picker.$emit('pick', date)
							this.calculationDate(-3)
						},
					},
				],
			},
			load_data: true,
			iscenter: {
				textAlign: 'center',
				background: '#f8f8f8',
				color: '#232323',
			},
			singletype: 1,
			type: 2,
			name: '',
			currentPage4: 1,
			Choicetype: 0,
			count: 1,
			piece: 0,
			isIndeterminate: false,
			checkAll: false,
			size: 10,
			checkModel: [],
			finishedConut: 0,
			unfinishedConut: 0,
			options: [
				{ value: '1', label: '新建' },
				{ value: '2', label: '认领' },
				{ value: '3', label: '孵化' },
				{ value: '4', label: '复制' },
				{ value: '5', label: '迁移' },
			],
			settype: false,
			Newlytype: false,
			Newlylist: [],
			summarylist: [],
			arr: [],
			UserInfo: {},
			branchCompany: [],
			sonCompany: [],
			departmentList: [],
			groupList: [],
			staffList: [],
			dialogLoding: false,
			selectForm: {
				value: '',
				startTime: '',
				endTime: '',
				input: '',
				departmentValue: {},
				groupValue: {},
				staffValue: {},
				branchCompany: {},
				sonCompany: {},
				mark: '',
				isTranslation: '',
			},
			staffId: '',
			companyId: 0,
			operateWidth: 200,
			loadingStatus: '',
			shopList: [],
			shopState: '',
			isGet: false,
			shopConfig: {},
		}
	},
	created() {
		this.UserInfo = JSON.parse(localStorage.getItem('role'))
		// console.log(this.UserInfo.system)
		this.init()
		this.getThisMonth()
		this.get_table_data()
		if (
			this.UserInfo.system !== 5 &&
			this.UserInfo.superDepartmentName !== '运营部'
		) {
			this.operateWidth = 80
		}
	},
	mounted() {
		if (isUpdate) {
			// this.currentPage4 = 1
			// this.size = 10
			// this.selectForm = this.$options.data().selectForm
			// this.get_table_data()
			this.resetForm('selectForm')
		}else{
			this.get_table_data();
		}
	},
	activated() {
		if (isUpdate) {
			this.currentPage4 = 1;
			this.size = 10;
			this.type = 2;
			this.resetForm('selectForm')
		} else {
			this.get_table_data();
		}
	},

	methods: {
		exportExcel,
		async exportData(){
			if(!this.isGet){
				const params1 = { staffId: this.UserInfo.rid };
				const res1 = await ajaxPost(Baseurl + "sellerController/selectSellerByStaffId", params1);
				if (res1.data.code == 200 && res1.data.data && res1.data.data.length > 0) {
					this.shopState = "real";
					this.shopList = res1.data.data.map(item => {
						item.shopName = item.shop_name;
						return item;
					});
				} else {
					const uid = this.UserInfo.rid;
					const companyId = this.UserInfo.company_id;
					const params = { uid, companyId };
					const res = await ajaxPost(Baseurl + "virtualSellerController/getVirtualSeller", params);
					if (res.data.code === 200 && res.data.data) {
						// 有虚拟店铺
						this.shopState = "virtual";
						this.shopList = [res.data.data].map(item => {
							item.isVirtual = true;
							return item;
						});
					}
				}
				this.isGet = true;
			}
			if(this.shopList.length == 0){
				this.$message.warning("当前角色没有店铺无法导出");
				return
			}
			const obj11 = {};
			this.shopList.forEach(item => {
				obj11[item.id] = item.shop_name;
			})

			const shop_name_text = this.shopList.map(item => item.shop_name).join("、");
			if(this.shopList.length > 1){
				this.$notify({
					title: '填写提醒',
					message: '导入的表中店铺名只能填写：' + (this.shopList.length == 1 ? shop_name_text : shop_name_text + "之一"),
					type: 'warning',
					position: 'top-right', // 右侧显示
					duration: 0,           // 设为 0 则不自动关闭，一直提示
					onClose: () => {
						// 触发此回调说明是用户手动点击了关闭按钮
						if (this.notifyInstance) {
							this.notifyInstance = null;
						}
					}
				});
			}
			
			const paramsData = {
				page: this.currentPage4,
				size: this.size,
				staffId: this.staffId, //this.input, //登录人id
				productType: '',
				startTime: this.selectForm.startTime,
				endTime: this.selectForm.endTime,
				idTitleSku: this.selectForm.input,
				statusAudit: String(this.type),
				companyId: this.companyId,
				isHasVariant: 0,
				isByEdit: 0,
				isByUpload: 0,
				mark: this.selectForm.mark,
				isTranslation: this.selectForm.isTranslation,
			}
			if (this.selectForm.input.length != 0) {
				sessionStorage.setItem('idTitleSku', JSON.stringify(this.selectForm.input))
			}
			if (JSON.parse(sessionStorage.getItem('idTitleSku'))) {
				paramsData.idTitleSku = JSON.parse(sessionStorage.getItem('idTitleSku'))
				this.selectForm.input = JSON.parse(sessionStorage.getItem('idTitleSku'))
				this.selectForm.startTime = ''
				this.selectForm.endTime = ''
			}
			if (this.selectForm.value) {
				paramsData.productType = Number(this.selectForm.value)
			}
			if (this.selectForm.value === '1') {
				paramsData.isHasVariant = Number(this.Choicetype)
			} else if (this.selectForm.value === '2') {
				paramsData.isByEdit = Number(this.Choicetype)
			} else if (this.selectForm.value === '3') {
				paramsData.isByUpload = Number(this.Choicetype)
			}
			ajaxPost(
				Baseurl + 'productController/selectAllProductsDetail',
				paramsData
			)
				.then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						const result = [];
						const header = [
							{label: '产品图片', key: 'productImgUrl',},
							{label: '产品安全法规图片', key: 'productSafetyImage',},
							{label: '店铺名', key: 'shop_name1',},
							// 中国（CNY）
							{ label: '中国-标题', key: 'ZH-title' },
							{ label: '中国-亮点', key: 'ZH-bluePoint' },
							{ label: '中国-关键字', key: 'ZH-keyword' },
							{ label: '中国-描述', key: 'ZH-briefIntroduction' },
							{ label: '中国-价格-CNY', key: 'ZH-productPrice-CNY' },

							// 美国（USD）
							{ label: '美国-标题', key: 'US-title' },
							{ label: '美国-亮点', key: 'US-bluePoint' },
							{ label: '美国-关键字', key: 'US-keyword' },
							{ label: '美国-描述', key: 'US-briefIntroduction' },
							{ label: '美国-价格-USD', key: 'US-productPrice-USD' },

							// 英国（GBP）
							{ label: '英国-标题', key: 'GB-title' },
							{ label: '英国-亮点', key: 'GB-bluePoint' },
							{ label: '英国-关键字', key: 'GB-keyword' },
							{ label: '英国-描述', key: 'GB-briefIntroduction' },
							{ label: '英国-价格-GBP', key: 'GB-productPrice-GBP' },

							// 德国（EUR）
							{ label: '德国-标题', key: 'DE-title' },
							{ label: '德国-亮点', key: 'DE-bluePoint' },
							{ label: '德国-关键字', key: 'DE-keyword' },
							{ label: '德国-描述', key: 'DE-briefIntroduction' },
							{ label: '德国-价格-EUR', key: 'DE-productPrice-EUR' },

							// 法国（EUR）
							{ label: '法国-标题', key: 'FR-title' },
							{ label: '法国-亮点', key: 'FR-bluePoint' },
							{ label: '法国-关键字', key: 'FR-keyword' },
							{ label: '法国-描述', key: 'FR-briefIntroduction' },
							{ label: '法国-价格-EUR', key: 'FR-productPrice-EUR' },

							// 意大利（EUR）
							{ label: '意大利-标题', key: 'IT-title' },
							{ label: '意大利-亮点', key: 'IT-bluePoint' },
							{ label: '意大利-关键字', key: 'IT-keyword' },
							{ label: '意大利-描述', key: 'IT-briefIntroduction' },
							{ label: '意大利-价格-EUR', key: 'IT-productPrice-EUR' },

							// 西班牙（EUR）
							{ label: '西班牙-标题', key: 'ES-title' },
							{ label: '西班牙-亮点', key: 'ES-bluePoint' },
							{ label: '西班牙-关键字', key: 'ES-keyword' },
							{ label: '西班牙-描述', key: 'ES-briefIntroduction' },
							{ label: '西班牙-价格-EUR', key: 'ES-productPrice-EUR' },

							// 荷兰（EUR）
							{ label: '荷兰-标题', key: 'NL-title' },
							{ label: '荷兰-亮点', key: 'NL-bluePoint' },
							{ label: '荷兰-关键字', key: 'NL-keyword' },
							{ label: '荷兰-描述', key: 'NL-briefIntroduction' },
							{ label: '荷兰-价格-EUR', key: 'NL-productPrice-EUR' },

							// 瑞典（SEK）
							{ label: '瑞典-标题', key: 'SE-title' },
							{ label: '瑞典-亮点', key: 'SE-bluePoint' },
							{ label: '瑞典-关键字', key: 'SE-keyword' },
							{ label: '瑞典-描述', key: 'SE-briefIntroduction' },
							{ label: '瑞典-价格-SEK', key: 'SE-productPrice-SEK' },

							// 波兰（PLN）
							{ label: '波兰-标题', key: 'PL-title' },
							{ label: '波兰-亮点', key: 'PL-bluePoint' },
							{ label: '波兰-关键字', key: 'PL-keyword' },
							{ label: '波兰-描述', key: 'PL-briefIntroduction' },
							{ label: '波兰-价格-PLN', key: 'PL-productPrice-PLN' },

							// 沙特阿拉伯（SAR）
							{ label: '沙特阿拉伯-标题', key: 'SA-title' },
							{ label: '沙特阿拉伯-亮点', key: 'SA-bluePoint' },
							{ label: '沙特阿拉伯-关键字', key: 'SA-keyword' },
							{ label: '沙特阿拉伯-描述', key: 'SA-briefIntroduction' },
							{ label: '沙特阿拉伯-价格-SAR', key: 'SA-productPrice-SAR' },

							// 加拿大（CAD）
							{ label: '加拿大-标题', key: 'CA-title' },
							{ label: '加拿大-亮点', key: 'CA-bluePoint' },
							{ label: '加拿大-关键字', key: 'CA-keyword' },
							{ label: '加拿大-描述', key: 'CA-briefIntroduction' },
							{ label: '加拿大-价格-CAD', key: 'CA-productPrice-CAD' },

							// 墨西哥（MXN）
							{ label: '墨西哥-标题', key: 'MX-title' },
							{ label: '墨西哥-亮点', key: 'MX-bluePoint' },
							{ label: '墨西哥-关键字', key: 'MX-keyword' },
							{ label: '墨西哥-描述', key: 'MX-briefIntroduction' },
							{ label: '墨西哥-价格-MXN', key: 'MX-productPrice-MXN' },

							// 日本（JPY）
							{ label: '日本-标题', key: 'JP-title' },
							{ label: '日本-亮点', key: 'JP-bluePoint' },
							{ label: '日本-关键字', key: 'JP-keyword' },
							{ label: '日本-描述', key: 'JP-briefIntroduction' },
							{ label: '日本-价格-JPY', key: 'JP-productPrice-JPY' },

							// 澳洲（AUD）
							{ label: '澳洲-标题', key: 'AU-title' },
							{ label: '澳洲-亮点', key: 'AU-bluePoint' },
							{ label: '澳洲-关键字', key: 'AU-keyword' },
							{ label: '澳洲-描述', key: 'AU-briefIntroduction' },
							{ label: '澳洲-价格-AUD', key: 'AU-productPrice-AUD' },

							// 阿联酋（AED）
							{ label: '阿联酋-标题', key: 'AE-title' },
							{ label: '阿联酋-亮点', key: 'AE-bluePoint' },
							{ label: '阿联酋-关键字', key: 'AE-keyword' },
							{ label: '阿联酋-描述', key: 'AE-briefIntroduction' },
							{ label: '阿联酋-价格-AED', key: 'AE-productPrice-AED' },

							// 新加坡（SGD）
							{ label: '新加坡-标题', key: 'SG-title' },
							{ label: '新加坡-亮点', key: 'SG-bluePoint' },
							{ label: '新加坡-关键字', key: 'SG-keyword' },
							{ label: '新加坡-描述', key: 'SG-briefIntroduction' },
							{ label: '新加坡-价格-SGD', key: 'SG-productPrice-SGD' },

							// 印度（INR）
							{ label: '印度-标题', key: 'IN-title' },
							{ label: '印度-亮点', key: 'IN-bluePoint' },
							{ label: '印度-关键字', key: 'IN-keyword' },
							{ label: '印度-描述', key: 'IN-briefIntroduction' },
							{ label: '印度-价格-INR', key: 'IN-productPrice-INR' },

							// 巴西（BRL）
							{ label: '巴西-标题', key: 'BR-title' },
							{ label: '巴西-亮点', key: 'BR-bluePoint' },
							{ label: '巴西-关键字', key: 'BR-keyword' },
							{ label: '巴西-描述', key: 'BR-briefIntroduction' },
							{ label: '巴西-价格-BRL', key: 'BR-productPrice-BRL' },

							{label: '品牌名称', key: 'brand'},
							{label: '厂商名称', key: 'manufacturer'},
							{label: '库存数量', key: 'stock'},
							{label: '父SKU', key: 'sku'},
							{label: '厂商编号', key: 'manufacturerNumber'},
							{label: '预处理时间', key: 'preprocessingTime'},
							{label: '来源地址', key: 'sourceLink'},
							{label: '备注', key: 'remarks'},
							{label: '产品定价-价格', key: 'productPrice'},
							{label: '产品定价-币种', key: 'priceCurrency'},
							{label: '状态', key: 'productStatus'},
							{label: '完成状态', key: 'statusAudit'},
							{label: '变体颜色', key: 'variant_color'},
							{label: '变体尺寸', key: 'variant_size'},
							{label: '变体标识', key: 'variant_variant_tag'},
							{label: '变体库存', key: 'variant_stock'},
							{label: '变体子SKU', key: 'variant_sku'},
							{label: '变体图片', key: 'variant_images'},
						];
						const priceObj = {};
						const priceHeader = [];
						for(let i = 0; i < data.length; i++){
							const item = {};
							const row = data[i];
							const variant = row['variantJson'] ? JSON.parse(row['variantJson']) : [];
							item['productImgUrl'] = row['productImgUrl'];
							item['productSafetyImage'] = row['productSafetyImage'];
							item["shop_name1"] = obj11[row['psSid']] ? obj11[row['psSid']] : "";
							const productDetail = data[i]['productDetail'];
							for(let j = 0; j < productDetail.length; j++){
								const title_key = `${productDetail[j]['areaName']}-title`;
								const bluePoint_key = `${productDetail[j]['areaName']}-bluePoint`;
								const keyword_key = `${productDetail[j]['areaName']}-keyword`;
								const briefIntroduction_key = `${productDetail[j]['areaName']}-briefIntroduction`;
								const price_key = `${productDetail[j]['areaName']}-productPrice-${productDetail[j]['priceCurrency']}`;
								item[title_key] = productDetail[j]['title'];
								item[bluePoint_key] = productDetail[j]['bluePoint'];
								item[keyword_key] = productDetail[j]['keyword'];
								item[briefIntroduction_key] = productDetail[j]['briefIntroduction'];
								item[price_key] = productDetail[j]['productPrice'];
							}
							item['brand'] = row['brand'];
							item['manufacturer'] = row['manufacturer'];
							item['stock'] = row['stock'];
							item['sku'] = row['sku'];
							item['manufacturerNumber'] = row['manufacturerNumber'];
							item['preprocessingTime'] = row['preprocessingTime'];
							item['sourceLink'] = row['sourceLink'];
							item['remarks'] = row['remarks'];
							item['productPrice'] = row['productPrice'];
							item['priceCurrency'] = row['priceCurrency'];

							item['productStatus'] = row['productStatus'];
							item['statusAudit'] = row['statusAudit'];
							if(!variant || variant.length === 0){
								result.push(item);
								continue;
							}
							for(let j = 0; j < variant.length; j++){
								const variantItem = variant[j];
								const itemCopy = { ...item }; 
								itemCopy['variant_color'] = variantItem['color'];
								itemCopy['variant_size'] = variantItem['size'];
								itemCopy['variant_father_sku'] = variantItem['father_sku'];
								itemCopy['variant_images'] = variantItem['images'];
								itemCopy['variant_sku'] = variantItem['sku'];
								itemCopy['variant_state'] = variantItem['state'];
								itemCopy['variant_stock'] = variantItem['stock'];
								itemCopy['variant_variant_order'] = variantItem['variant_order'];
								itemCopy['variant_variant_tag'] = variantItem['variant_tag'];
								const product_price = variantItem['product_price'] ? JSON.parse(variantItem['product_price']) : {};
								for(const key in product_price){
									const k1 = `variant_price_${key}_value_${product_price[key]['currency']}`;
									const label1 = `变体价格-${key}-${product_price[key]['currency']}`;
									itemCopy[k1] = product_price[key]['value'];
									if(!priceObj[key]){
										priceObj[key] = true;
										priceHeader.push({label: label1, key: k1});
									}
								}

								result.push(itemCopy);
							}
						}
						header.push(...priceHeader);
						const obj = {};
						for(let i = 0; i < header.length; i++){
							obj[header[i].label] = header[i]['key'];
						}

						this.exportExcel(header, result, `产品数据导出.xlsx`);
					}else{
						this.$message({
							type: 'error',
							message: "导出异常",
						})
					}
					// console.log(this.summarylist);
				})
				.catch(function (e) {
					console.log(e)
				})
		},
		/** 校验文件类型、大小 */
		beforeUpload(file) {
			const isExcel =
				file.type ===
				"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
				file.type === "application/vnd.ms-excel";

			if (!isExcel) {
				this.$message.error("只能上传 Excel 文件（.xls 或 .xlsx）");
				return false;
			}
			return true;
		},
		async getCommonSetting(staffId){
			const res = await ajaxPost(Baseurl + 'commonSettingController/getCommonSettingByStaffId', {staffId});
			if(res['data']['code'] == 200){
				return res['data']['data']
			}
			return null
		},
		/** 读取 Excel 文件并解析 */
		async readExcel(file1) {
			const reader = new FileReader();
			if (!this.isGet) {
				const params1 = { staffId: this.UserInfo.rid };
				const res1 = await ajaxPost(Baseurl + "sellerController/selectSellerByStaffId", params1);
				if (res1.data.code == 200 && res1.data.data && res1.data.data.length > 0) {
					this.shopState = "real";
					this.shopList = res1.data.data.map(item => {
						item.shopName = item.shop_name;
						return item;
					});
				} else {
					const uid = this.UserInfo.rid;
					const companyId = this.UserInfo.company_id;
					const params = { uid, companyId };
					const res = await ajaxPost(Baseurl + "virtualSellerController/getVirtualSeller", params);
					if (res.data.code === 200 && res.data.data) {
						// 有虚拟店铺
						this.shopState = "virtual";
						this.shopList = [res.data.data].map(item => {
							item.isVirtual = true;
							return item;
						});
					}
				}
				this.isGet = true;
			}
			if (this.shopList.length == 0) {
				this.$message.warning("当前角色没有店铺无法导出");
				return
			}
			const obj11 = {};
			this.shopList.forEach(item => {
				obj11[item.id] = item.shop_name;
			})

			const shop_name_text = this.shopList.map(item => item.shop_name).join("、");
			if (this.shopList.length > 1) {
				this.$notify({
					title: '填写提醒',
					message: '导入的表中店铺名只能填写：' + (this.shopList.length == 1 ? shop_name_text : shop_name_text + "之一"),
					type: 'warning',
					position: 'top-right', // 右侧显示
					duration: 0,           // 设为 0 则不自动关闭，一直提示
					onClose: () => {
						// 触发此回调说明是用户手动点击了关闭按钮
						if (this.notifyInstance) {
							this.notifyInstance = null;
						}
					}
				});
			}

			reader.onload = async (e) => {
				const data = new Uint8Array(e.target.result);
				const workbook = XLSX.read(data, { type: "array" });

				// 取第一张表
				const firstSheetName = workbook.SheetNames[0];
				const sheet = workbook.Sheets[firstSheetName];

				// 转成 JSON
				const excelData = XLSX.utils.sheet_to_json(sheet, { defval: "" });
				const mapping = {
					"店铺名": "shop_name1",
					"产品图片": "productImgUrl",
					"产品安全法规图片": "productSafetyImage",
					"中国-标题": "ZH-title",
					"中国-亮点": "ZH-bluePoint",
					"中国-关键字": "ZH-keyword",
					"中国-描述": "ZH-briefIntroduction",
					"中国-价格-CNY": "ZH-productPrice-CNY",
					"美国-标题": "US-title",
					"美国-亮点": "US-bluePoint",
					"美国-关键字": "US-keyword",
					"美国-描述": "US-briefIntroduction",
					"美国-价格-USD": "US-productPrice-USD",
					"英国-标题": "GB-title",
					"英国-亮点": "GB-bluePoint",
					"英国-关键字": "GB-keyword",
					"英国-描述": "GB-briefIntroduction",
					"英国-价格-GBP": "GB-productPrice-GBP",
					"德国-标题": "DE-title",
					"德国-亮点": "DE-bluePoint",
					"德国-关键字": "DE-keyword",
					"德国-描述": "DE-briefIntroduction",
					"德国-价格-EUR": "DE-productPrice-EUR",
					"法国-标题": "FR-title",
					"法国-亮点": "FR-bluePoint",
					"法国-关键字": "FR-keyword",
					"法国-描述": "FR-briefIntroduction",
					"法国-价格-EUR": "FR-productPrice-EUR",
					"意大利-标题": "IT-title",
					"意大利-亮点": "IT-bluePoint",
					"意大利-关键字": "IT-keyword",
					"意大利-描述": "IT-briefIntroduction",
					"意大利-价格-EUR": "IT-productPrice-EUR",
					"西班牙-标题": "ES-title",
					"西班牙-亮点": "ES-bluePoint",
					"西班牙-关键字": "ES-keyword",
					"西班牙-描述": "ES-briefIntroduction",
					"西班牙-价格-EUR": "ES-productPrice-EUR",
					"荷兰-标题": "NL-title",
					"荷兰-亮点": "NL-bluePoint",
					"荷兰-关键字": "NL-keyword",
					"荷兰-描述": "NL-briefIntroduction",
					"荷兰-价格-EUR": "NL-productPrice-EUR",
					"瑞典-标题": "SE-title",
					"瑞典-亮点": "SE-bluePoint",
					"瑞典-关键字": "SE-keyword",
					"瑞典-描述": "SE-briefIntroduction",
					"瑞典-价格-SEK": "SE-productPrice-SEK",
					"波兰-标题": "PL-title",
					"波兰-亮点": "PL-bluePoint",
					"波兰-关键字": "PL-keyword",
					"波兰-描述": "PL-briefIntroduction",
					"波兰-价格-PLN": "PL-productPrice-PLN",
					"沙特阿拉伯-标题": "SA-title",
					"沙特阿拉伯-亮点": "SA-bluePoint",
					"沙特阿拉伯-关键字": "SA-keyword",
					"沙特阿拉伯-描述": "SA-briefIntroduction",
					"沙特阿拉伯-价格-SAR": "SA-productPrice-SAR",
					"加拿大-标题": "CA-title",
					"加拿大-亮点": "CA-bluePoint",
					"加拿大-关键字": "CA-keyword",
					"加拿大-描述": "CA-briefIntroduction",
					"加拿大-价格-CAD": "CA-productPrice-CAD",
					"墨西哥-标题": "MX-title",
					"墨西哥-亮点": "MX-bluePoint",
					"墨西哥-关键字": "MX-keyword",
					"墨西哥-描述": "MX-briefIntroduction",
					"墨西哥-价格-MXN": "MX-productPrice-MXN",
					"日本-标题": "JP-title",
					"日本-亮点": "JP-bluePoint",
					"日本-关键字": "JP-keyword",
					"日本-描述": "JP-briefIntroduction",
					"日本-价格-JPY": "JP-productPrice-JPY",
					"澳洲-标题": "AU-title",
					"澳洲-亮点": "AU-bluePoint",
					"澳洲-关键字": "AU-keyword",
					"澳洲-描述": "AU-briefIntroduction",
					"澳洲-价格-AUD": "AU-productPrice-AUD",
					"阿联酋-标题": "AE-title",
					"阿联酋-亮点": "AE-bluePoint",
					"阿联酋-关键字": "AE-keyword",
					"阿联酋-描述": "AE-briefIntroduction",
					"阿联酋-价格-AED": "AE-productPrice-AED",
					"新加坡-标题": "SG-title",
					"新加坡-亮点": "SG-bluePoint",
					"新加坡-关键字": "SG-keyword",
					"新加坡-描述": "SG-briefIntroduction",
					"新加坡-价格-SGD": "SG-productPrice-SGD",
					"印度-标题": "IN-title",
					"印度-亮点": "IN-bluePoint",
					"印度-关键字": "IN-keyword",
					"印度-描述": "IN-briefIntroduction",
					"印度-价格-INR": "IN-productPrice-INR",
					"巴西-标题": "BR-title",
					"巴西-亮点": "BR-bluePoint",
					"巴西-关键字": "BR-keyword",
					"巴西-描述": "BR-briefIntroduction",
					"巴西-价格-BRL": "BR-productPrice-BRL",
					"品牌名称": "brand",
					"厂商名称": "manufacturer",
					"库存数量": "stock",
					"父SKU": "sku",
					"厂商编号": "manufacturerNumber",
					"预处理时间": "preprocessingTime",
					"来源地址": "sourceLink",
					"备注": "remarks",
					"产品定价-价格": "productPrice",
					"产品定价-币种": "priceCurrency",
					"状态": "productStatus",
					"完成状态": "statusAudit",
					"变体颜色": "variant_color",
					"变体尺寸": "variant_size",
					"变体标识": "variant_variant_tag",
					"变体库存": "variant_stock",
					"变体子SKU": "variant_sku",
					"变体图片": "variant_images",
					"变体价格-GB-GBP": "variant_price_GB_value_GBP",
					"变体价格-DE-EUR": "variant_price_DE_value_EUR",
					"变体价格-FR-EUR": "variant_price_FR_value_EUR",
					"变体价格-IT-EUR": "variant_price_IT_value_EUR",
					"变体价格-ES-EUR": "variant_price_ES_value_EUR",
					"变体价格-NL-EUR": "variant_price_NL_value_EUR",
					"变体价格-SE-SEK": "variant_price_SE_value_SEK",
					"变体价格-PL-PLN": "variant_price_PL_value_PLN",
					"变体价格-SA-SAR": "variant_price_SA_value_SAR",
					"变体价格-US-USD": "variant_price_US_value_USD",
					"变体价格-CA-CAD": "variant_price_CA_value_CAD",
					"变体价格-MX-MXN": "variant_price_MX_value_MXN",
					"变体价格-JP-JPY": "variant_price_JP_value_JPY",
					"变体价格-AU-AUD": "variant_price_AU_value_AUD",
					"变体价格-AE-AED": "variant_price_AE_value_AED",
					"变体价格-SG-SGD": "variant_price_SG_value_SGD",
					"变体价格-IN-INR": "variant_price_IN_value_INR",
					"变体价格-BR-BRL": "variant_price_BR_value_BRL",
					"变体价格-ZH-CNY": "variant_price_ZH_value_CNY"
				}
				const resultObj = {};
				const shop_name_obj = {};
				let arr1 = [];
				this.shopList.forEach((item ) => {
					shop_name_obj[item.shop_name] = item.id;
					arr1.push(item.shop_name);
				})
				const obj222 = {};
				for(let i = 0; i < excelData.length; i++){
					const row = excelData[i];
					const mappedRow = {};
					for (const key in row) {
						if (mapping[key]) {
							mappedRow[mapping[key]] = row[key] ? (row[key] + '').trim() : '';
						}
					}
					
					if(!shop_name_obj[mappedRow["shop_name1"]]){
						this.$message.error("店铺只能填写" + arr1.join("、"));
						return
					}
					if (!obj222[mappedRow['shop_name1']] && mappedRow['shop_name1']) {
						obj222[mappedRow['shop_name1']] = 1;
					}
					const key = (mappedRow['ZH-bluePoint'] ? JSON.stringify(mappedRow['ZH-bluePoint']) : '') + mappedRow['ZH-briefIntroduction'] + mappedRow['ZH-keyword'] + mappedRow['ZH-title'];
					if(!resultObj[key]){
						resultObj[key] = [];
					}
					
					resultObj[key].push(mappedRow);
				}
				if(Object.keys(obj222).length != 1){
					this.$message.warning("表格中的店铺只能填入1个");
					return
				}
				const shop_name_text = Object.keys(obj222)[0];
				const sid = shop_name_obj[shop_name_text];
				if(!sid){
					this.$message.error("上传失败")
					return 
				}
				const staffId = localStorage.getItem("role") ? JSON.parse(localStorage.getItem("role"))['rid'] : '';
				if(!staffId){
					this.$message.error("上传失败")
					return 
				}
				const result = [];
				for(let k in resultObj){
					await this.getShopConfig(sid);
					const items = resultObj[k];
					const products = [];
					const areaNameObj = {};
					const firstItem = items[0];
					const productPriceObject = {};
					for(let k in firstItem){
						if(/^.{2}-bluePoint/.test(k)){
							const areaName = k.split('-')[0];
							if(!areaNameObj[areaName]){
								areaNameObj[areaName] = {};
								areaNameObj[areaName]['areaName'] = areaName;
							}
							const arr1 = firstItem[k] ? JSON.parse(firstItem[k]) : ["", "", "", "", ""];
							for(let i = 0; i < arr1.length; i++){
								arr1[i] = arr1[i].substring(0,500);
							}
							areaNameObj[areaName]['bluePoints'] = arr1;
						}
						if(/^.{2}-briefIntroduction/.test(k)){
							const areaName = k.split('-')[0];
							if(!areaNameObj[areaName]){
								areaNameObj[areaName] = {};
								areaNameObj[areaName]['areaName'] = areaName;
							}
							areaNameObj[areaName]['briefIntroduction'] = firstItem[k] ? (firstItem[k] + '').substring(0,2000) : "";
						}
						if(/^.{2}-keyword/.test(k)){
							const areaName = k.split('-')[0];
							if(!areaNameObj[areaName]){
								areaNameObj[areaName] = {};
								areaNameObj[areaName]['areaName'] = areaName;
							}
							areaNameObj[areaName]['keyword'] = firstItem[k] ? (firstItem[k] + '').substring(0, 250) : "";
						}
						if(/^.{2}-title/.test(k)){
							const areaName = k.split('-')[0];
							if(!areaNameObj[areaName]){
								areaNameObj[areaName] = {};
								areaNameObj[areaName]['areaName'] = areaName;
							}
							areaNameObj[areaName]['title'] = firstItem[k] ? (firstItem[k] + '').substring(0, 180) : "";
						}
						
						// "ZH-productPrice"
						if(/^.{2}-productPrice/.test(k)){
							const areaName = k.split('-')[0];
							const bizhong = k.split('-')[2];
							if(!productPriceObject[areaName]){
								productPriceObject[areaName] = {};
							}
							productPriceObject[areaName]['value'] = firstItem[k] ? firstItem[k] : "";
							productPriceObject[areaName]['currency'] = bizhong ? bizhong : "";
						}
					}
					// const commonSetting = await this.getCommonSetting(staffId);
					// if(!commonSetting){
					// 	this.$message.error("获取通用设置失败")
					// 	return
					// }
					const product = {
						"id": "",
						brand: this.shopConfig['ZH'].brand,
						companyId: this.UserInfo.company_id,
						manufacturer: this.shopConfig['ZH'].manufacturer,
						manufacturerNumber: this.shopConfig['ZH'].manufacturerNumber,
						preprocessingTime: this.shopConfig['ZH'].preprocessingTime,
						"productImgUrls": items[0]['productImgUrl'] ? JSON.parse(items[0]['productImgUrl']) : [],
						"productSafetyImages": items[0]['productSafetyImage'] ? JSON.parse(items[0]['productSafetyImage']) : [],
						"remarks": items[0]['remarks'] ? items[0]['remarks'] : '',
						"sourceLink": items[0]['sourceLink'] ? JSON.stringify(JSON.parse(items[0]['sourceLink'])) : [],
						sku: this.shopConfig['ZH'].sku,
						"productStatus": "New",
						"statusAudit": "2",
						sid: sid,
						shopIsVirtual: this.shopState === "real" ? 0 : 1, // 0:真实店铺 1:虚拟店铺
						"staffId": staffId,
						stock: this.shopConfig['ZH'].stock,
						"productPriceObject": JSON.stringify(productPriceObject)
					}
					for(const key in areaNameObj){
						const item1 = areaNameObj[key];
						const config = this.shopConfig[key];
						if(config){
							item1.brand = config.brand;
							item1.manufacturer = config.manufacturer;
							item1.manufacturerNumber = config.manufacturerNumber;
							item1.preprocessingTime = config.preprocessingTime;
							item1.sku = config.sku;
							item1.stock = config.stock;
							item1.sid = this.selectedShopId;
							item1.shopIsVirtual = this.shopState === "real" ? 0 : 1; // 0:真实店铺 1:虚拟店铺
							if (!item1.id) delete item1.id
							products.push(item1);
						}
					}
					
					const productPrice = {
						"productUnitPrice": "1",
						"productWeight": "1",
						"productLenght": "1",
						"productWidth": "1",
						"productHeight": "1",
						"id": ""
					};
					
					const variants = [];
					for(let i = 0; i < items.length; i++){
						const productPrice = {};
						// "变体价格-ZH-CNY": "variant_price_ZH_value_CNY"
						for(let k1 in items[i]){
							if(/variant_price_.{2}_value/.test(k1)){
								const arr = k1.split('_');
								productPrice[arr[2]] = {
									value: items[i][k1],
									currency: arr[4]
								}
							}
						}
						let sku = items[i]['sku'];
						if(!items[i]['variant_color'] && !items[i]['variant_size']){
							continue
						}
						if(items[i]['variant_color']){
							sku += ('-' + items[i]['variant_color'])
						}
						if(items[i]['variant_size']){
							sku += ('-' + items[i]['variant_size'])
						}
						const row1 = {
							"areaName": "ZH",
							"color": items[i]['variant_color'],
							"size": items[i]['variant_size'],
							"variantTag": items[i]['variant_variant_tag'],
							"sku": sku,
							"fatherSku": items[i]['sku'],
							"productPrice": JSON.stringify(productPrice),
							"stock": items[i]['variant_stock'],
							"imagesList": items[i]['variant_images'] ? JSON.parse(items[i]['variant_images']) : [],
							"inputPrice": "",
							"eanUpc": "",
							"showPrice": productPrice['ZH'] ? productPrice['ZH']['value'] : '',
							"variantOrder": i
						}
						variants.push(row1);
					}
					const API = Baseurl + 'productController/insertProduct'
					const params = {
						product,
						productPrice,
						products,
						variants,
						sid: sid,
						isVirtual: this.shopState === "real" ? 0 : 1
					}
					const resp = await ajaxPost(API, params);
					console.log(resp);
				}
				this.$message.success("Excel 导入成功");
			};

			reader.readAsArrayBuffer(file1.raw);
		},
		async getShopConfig(sid) {
			this.shopConfig = {};
			const res = await ajaxPost(Baseurl + "sellerCommonSettingController/getSellerCommonSettingList", {
				sid: sid,
				staffId: this.UserInfo.rid,
				isVirtual: this.shopState === "real" ? 0 : 1, // 0:真实店铺 1:虚拟店铺
			});
			if (res.data.code === 200 && res.data.data) {
				const dataList = res.data.data;
				const obj = {};
				dataList.forEach(item => {
					obj[item.countryCode] = item;
				})
				this.$set(this, 'shopConfig', obj);
				// this.shopConfig = obj;
				// if (!this.productId) {
				// 	this.shopConfig = obj;
				// 	this.$set(this.productInfo, 'sku', obj[this.currentCountryName] ? obj[this.currentCountryName].sku : '');
				// 	this.$set(this.productInfo, 'stock', obj[this.currentCountryName] ? obj[this.currentCountryName].stock : '');
				// 	this.$set(this.productInfo, 'areaName', this.currentCountryName);
				// }
			}
		},
		batchCompletion(){
			let batch_select1 = JSON.parse(sessionStorage.getItem('batch_select1'))
			if(batch_select1.length == 0){
				this.$message.error("请先选择商品")
				return
			}
			const arr = batch_select1.map(item => item.productNumber)
			ajaxPost(Baseurl + 'productController/batchCompletion', {
				arr: arr
			}).then((res) => {
					if (res.data.code == 200) {
						this.$message({
							type: 'success',
							message: '批量完成 成功!',
						})
						this.dialogLoding = false
						this.synchronizationDialog = false
						this.batch_select1 = []
						sessionStorage.removeItem('batch_select1')
						this.$refs.multipleTable.clearSelection();
						this.search();
					} else {
						this.$message({
							type: 'error',
							message: res.data.message,
						})
						this.dialogLoding = false
					}
				})
				.catch((e) => {
					console.log(e)
				})
			
		},
		clickElUpload(){
			// 找到 el-upload 内部真实的 input 并触发点击
			const up = this.$refs.uploader;
			if (!up || !up.$el) return;
			const input = up.$el.querySelector('input[type="file"]');
			if (input) input.click();

		},
		toggleSelectAll(synchronizationList) {
			if (this.isAllSelected) {
				this.radio = synchronizationList.flatMap(item =>
					item.shopInfos.map(shop => shop.shopId)
				);
			} else {
				this.radio = [];
			}
		}
		,
		clickSynchronization() {
			let paramsData = []
			this.dialogLoding = true
			let batch_select1 = JSON.parse(sessionStorage.getItem('batch_select1'))
			if (batch_select1.length != 0 || batch_select1 != null) {
				for (let index = 0; index < this.radio.length; index++) {
					for (let i = 0; i < batch_select1.length; i++) {
						paramsData.push({
							productNumber: batch_select1[i].productNumber,
							sellerId: null,
							countryMark: {},
							id: batch_select1[i].id
						})
					}
				}
			} else {
				for (let index = 0; index < this.radio.length; index++) {
					paramsData.push({
						productNumber: this.selectTemporary.productNumber,
						sellerId: null,
						countryMark: {},
						id: null
					})
				}
			}
			let paramsDataO = []
			for (let j = 0; j < this.radio.length; j++) {
				for (let p = 0; p < this.synchronizationList.length; p++) {
					for (let o = 0; o < this.synchronizationList[p].shopInfos.length; o++) {
						if (this.radio[j] == this.synchronizationList[p].shopInfos[o].shopId) {
							for (let m = 0; m < paramsData.length; m++) {
								paramsDataO.push({
									productNumber: paramsData[m].productNumber,
									sellerId: this.synchronizationList[p].shopInfos[o].sellerId,
									countryMark: {
										area: this.synchronizationList[p].countryMark,
										marketPlaceId: this.synchronizationList[p].marketplaceId
									},
									// id: paramsData[m].id
								})
							}
						}
					}
				}
			}
			// 去重逻辑
			const uniqueData = this.uniqueData(paramsDataO)
			paramsData = uniqueData
			const API = Baseurl + 'amazonProductListing/preReleaseProduct'
			ajaxPost(API, paramsData)
				.then((res) => {
					if (res.data.code == 200) {
						this.$message({
							type: 'success',
							message: '同步成功!',
						})
						this.dialogLoding = false
						this.synchronizationDialog = false
						this.batch_select1 = []
						sessionStorage.removeItem('batch_select1')
						this.$refs.multipleTable.clearSelection();
					} else {
						this.$message({
							type: 'error',
							message: res.data.message,
						})
						this.dialogLoding = false
					}
				})
				.catch((e) => {
					console.log(e)
				})
		},
		uniqueData(list) {
			const uniqueCombinations = new Set();
			return list.filter(item => {
				const combination = `${item.productNumber}-${item.countryMark.area}`;
				if (!uniqueCombinations.has(combination)) {
					uniqueCombinations.add(combination);
					return true;
				}
				return false;
			});
		},
		async synchronization(e) {
			if (e != 2) {
				if (JSON.parse(sessionStorage.getItem('batch_select1')) == null || JSON.parse(sessionStorage.getItem('batch_select1')).length == 0) {
					this.$alert('请至少勾选一件产品！', '提示', {
						confirmButtonText: '确定',
					})
					return
				}
			}
			this.synchronizationDialog = true
			this.radio = []
			const API = Baseurl + 'amazonProductListing/selectAmazonShopByRid'
			const paramsData = { rid: JSON.parse(localStorage.getItem('role')).rid, system: JSON.parse(localStorage.getItem('role')).system }
			ajaxPost(API, paramsData)
				.then((res) => {
					this.synchronizationList = res.data.data
				})
				.catch((e) => {
					console.log(e)
				})
			this.selectTemporary = e
		},
		handleClear(){
			sessionStorage.removeItem('idTitleSku')
		},
		Change_Inp(value) {
			// console.log(value)
			if (value != '') {
				this.selectForm.startTime = ''
				this.selectForm.endTime = ''
			} else {
				this.getThisMonth()
			}
		},
		// 条件搜索
		async search() {
			await this.$nextTick();
			// let { startTime, endTime } = this.selectForm
			// if (this.selectForm.input == '') {
			// 	if (startTime && endTime) {
			// 		var Date1 = Date.parse(startTime)
			// 		var Date2 = Date.parse(endTime)
			// 		var days = (Date2 - Date1) / (1 * 24 * 60 * 60 * 1000)
			// 		// console.log(days)
			// 		if (days > 62) {
			// 			this.$message({
			// 				type: 'info',
			// 				message: '日期选择区间不能大于62天，请重新选择！',
			// 			})
			// 			return
			// 		}
			// 		const startDate = new Date(startTime).getTime()
			// 		const endDate = new Date(endTime).getTime()
			// 		if (startDate === endDate) {
			// 			const endTimeArr = endTime.split(' ')
			// 			endTimeArr[1] = '23:59:59'
			// 			this.selectForm.endTime = endTimeArr.join(' ')
			// 		}
			// 	} else {
			// 		this.$message({
			// 			type: 'error',
			// 			message: '请选择查询日期！',
			// 		})
			// 		return
			// 	}
			// }
			this.currentPage4 = 1
			this.get_table_data()
			// console.log(new Date(that.startTime).getTime()); //时间戳
		},

		init() {
			const {
				rid,
				system,
				company_id: companyId,
				type: companyType,
				superDepartmentName,
			} = this.UserInfo
			this.companyId = companyId
			this.staffId = rid
			let type = ''
			if (companyType === 1) {
				type = 'branchCompany'
				if (
					superDepartmentName === '客服部' ||
					superDepartmentName === '常规客服部'
				) {
					type = 'sonCompany'
				}
			} else if (companyType === 2) {
				type = 'sonCompany'
			} else if (system < 3) {
				type = 'departmentList'
			} else if (system === 3) {
				type = 'groupList'
			} else if (system === 4) {
				type = 'staffList'
			} else {
				return
			}
			this.getNextPower(rid, system, type)
		},
		getThisMonth() {
			const nowDate = new Date()
			const nowTimeStamp = nowDate.getTime()
			const nowYear = nowDate.getFullYear()
			const nowMonth = nowDate.getMonth() + 1
			const nowDay = nowDate.getDate()
			const startTimeStamp = nowTimeStamp - 3600 * 1000 * 24 * 30
			const startDate = new Date(startTimeStamp)
			const startYear = startDate.getFullYear()
			const startMonth = startDate.getMonth() + 1
			const startDay = startDate.getDate()

			this.selectForm.startTime = `${startYear}-${startMonth}-${startDay} 00:00:00`
			this.selectForm.endTime = `${nowYear}-${nowMonth}-${nowDay} 23:59:59`
		},
		calculationDate(type = 0) {
			const date = new Date()
			const year = date.getFullYear()
			const month = date.getMonth() + 1
			const day = date.getDate()
			// 计算新的月份和年份，确保处理负数和跨年的情况
			const newYear = year + Math.floor((month + type - 1) / 12);
			const newMonth = (month + type - 1 + 12) % 12 + 1;
			this.selectForm.startTime = `${newYear}-${newMonth + type}-01 00:00:00`

			const prevStamp =
				new Date(year, month + type, day).getTime() -
				3600 * 1000 * 24 * day
			const prevMonth = `${new Date(prevStamp).getFullYear()}-${new Date(
				prevStamp
			).getMonth() + 1}-${new Date(prevStamp).getDate()}`
			this.selectForm.endTime = `${prevMonth} 23:59:59`
		},
		itemPrice(item) {
			const itemPrice = item.productPrice
				? item.productPrice +
				(item.priceCurrency ? `(${item.priceCurrency})` : '')
				: ''
			return itemPrice
		},
		getNextPower(rid, system, type) {
			const API = Baseurl + 'roleController/selectNextInfoByRid'
			const paramsData = { rid, system, companyId: this.companyId }
			ajaxPost(API, paramsData)
				.then((res) => {
					const {
						data: { code, data },
					} = res
					if (code === 200) {
						this[type] = data.next
					}
				})
				.catch((e) => {
					console.log(e)
				})
		},
		selectChange(event, type) {
			const { rid, system, company_id: companyId } = event
			companyId && (this.companyId = companyId)
			this.getNextPower(rid, system, type)
			if (type === 'sonCompany') {
				this.selectForm.sonCompany = {}
				this.selectForm.departmentValue = {}
				this.selectForm.groupValue = {}
				this.selectForm.staffValue = {}
				this.sonCompany = []
				this.departmentList = []
				this.groupList = []
				this.staffList = []
			} else if (type === 'departmentList') {
				this.selectForm.departmentValue = {}
				this.selectForm.groupValue = {}
				this.selectForm.staffValue = {}
				this.departmentList = []
				this.groupList = []
				this.staffList = []
			} else if (type === 'groupList') {
				this.selectForm.groupValue = {}
				this.selectForm.staffValue = {}
				this.groupList = []
				this.staffList = []
			} else if (type === 'staffList') {
				this.selectForm.staffValue = {}
				this.staffList = []
			}
			this.staffId = rid
		},
		toOutPath(path) {
			return path.substr(0, 7).toLowerCase() == 'https://'
				? path
				: 'https://' + path
		},
		resetForm(formName) {
			this.$refs[formName].resetFields()
			this.staffId = this.UserInfo.rid
			this.branchCompany = []
			this.sonCompany = []
			this.departmentList = []
			this.groupList = []
			this.staffList = []
			this.Newlytype = false
			this.selectForm.input = ''
			sessionStorage.removeItem('idTitleSku');
			this.init()
			this.get_table_data()
		},
		complete(index) {
			this.currentPage4 = 1
			this.summarylist = []
			this.count = 0
			this.type = index

			// if (index == 1) {
			//     this.singletype = null;
			//     this.statusAudit = 2;
			// } else {
			//     this.singletype = null;
			//     this.statusAudit = 1;
			// }

			this.get_table_data()
		},
		get_table_data() {
			let idTitleSku1 = this.selectForm.input;
			var that = this
			this.load_data = true
			if (this.selectForm.input.length != 0) {
				sessionStorage.setItem('idTitleSku', JSON.stringify(this.selectForm.input))
			}
			if (JSON.parse(sessionStorage.getItem('idTitleSku'))) {
				idTitleSku1 = JSON.parse(sessionStorage.getItem('idTitleSku'))
				this.selectForm.input = JSON.parse(sessionStorage.getItem('idTitleSku'))
				// this.selectForm.startTime = ''
				// this.selectForm.endTime = ''
			} else {
				// this.getThisMonth();
			}
			const paramsData = {
				page: this.currentPage4,
				size: this.size,
				staffId: this.staffId, //this.input, //登录人id
				productType: '',
				startTime: this.selectForm.startTime,
				endTime: this.selectForm.endTime,
				idTitleSku: idTitleSku1,
				statusAudit: String(this.type),
				companyId: this.companyId,
				isHasVariant: 0,
				isByEdit: 0,
				isByUpload: 0,
				mark: this.selectForm.mark,
				isTranslation: this.selectForm.isTranslation,
			}

			if (this.selectForm.value) {
				paramsData.productType = Number(this.selectForm.value)
			}
			if (this.selectForm.value === '1') {
				paramsData.isHasVariant = Number(this.Choicetype)
			} else if (this.selectForm.value === '2') {
				paramsData.isByEdit = Number(this.Choicetype)
			} else if (this.selectForm.value === '3') {
				paramsData.isByUpload = Number(this.Choicetype)
			}
			ajaxPost(
				Baseurl + 'productController/selectAllProducts',
				paramsData
			)
				.then((res) => {
					const { code, data } = res.data
					this.load_data = false
					if (code === 200) {
						data.list.forEach((item) => {
							item.sourceLinks = item.sourceLinks.filter(
								(item) => !!item
							)
						})
						this.summarylist = data.list
						this.count = data.total
						this.unfinishedConut = data.navigateLastPage
						this.finishedConut = data.navigateFirstPage
					}
					// console.log(this.summarylist);
				})
				.catch(function (e) {
					console.log(e)
				})
		},
		// 删除
		removeId(id) {
			var newarr = []
			newarr.push(id)
			this.$confirm('此操作将永久删除该产品, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => {
					this.load_data = true
					ajaxPost(Baseurl + 'productController/deleteProductById', {
						ids: newarr,
					}).then((res) => {
						this.load_data = false
						if (res.data.code == 200) {
							this.$message({
								type: 'success',
								message: '删除成功!',
							})
							this.get_table_data()
						} else {
							this.$message({
								type: 'error',
								message: res.data.data,
							})
						}
					})
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除',
					})
				})
		},
		// 复制
		copy(id) {
			this.load_data = true
			ajaxPost(Baseurl + 'productController/copyProductById', {
				id: id,
			}).then((res) => {
				this.load_data = false
				// console.log(res);
				if (res.data.code == 200) {
					this.$message({
						type: 'success',
						message: '复制成功!',
					})
					this.get_table_data()
				} else {
					this.$message({
						type: 'error',
						message: res.data.message,
					})
				}
			})
		},
		// 编辑
		editId(id) {
			this.$router.push({
				path: '/commodity/product/EstablishProduct',
				query: {
					id: id,
				},
			})
		},
		handleSelectionChange(val) {
			console.log(val)
		},
		handleSizeChange(val) {
			this.size = val
			this.get_table_data()
		},
		handleCurrentChange(val) {
			this.currentPage4 = val
			this.get_table_data()
		},
		// 显示 隐藏
		setdisplay(item) {
			item.settype = !item.settype
		},
		Choice(index) {
			this.Choicetype = index
		},
		// 选中框
		Selection(item) {
			console.log(item)

			this.arr.push(item.id)
			console.log(this.arr)
			if (item.chatype) {
				this.piece++
			} else {
				this.piece--
			}
			if (this.summarylist.length > this.piece) {
				this.checkAll = false
			} else {
				this.checkAll = true
			}
		},
		selectChanged(val) {
			this.Choicetype = 0
			if (val === '1') {
				this.name = '新建'
				this.Newlylist = [
					{ name: '全部' },
					{ name: '有变体' },
					{ name: '无变体' },
				]
			} else if (val === '3') {
				this.name = '孵化'
				this.Newlylist = [{ name: '全部' }]
				// , { name: "已使用" }, { name: "未使用" } 孵化暂时没有这，先不用了
			} else if (val === '2') {
				this.name = '认领'
				this.Newlylist = [
					{ name: '全部' },
					{ name: '已修改' },
					{ name: '未修改' },
				]
			} else {
				this.Newlytype = false
				return
			}
			this.Newlytype = true
		},

		edit() {
			if (this.piece == 0) {
				this.$alert('请至少勾选一件产品！', '提示', {
					confirmButtonText: '确定',
				})
			} else {
				this.$refs.CommodityFrame.init(this.batch_select) //子级的init
			}
		},
		translate() {
			if (this.piece == 0) {
				this.$alert('请至少勾选一件产品！', '提示', {
					confirmButtonText: '确定',
				})
			} else {
				this.$confirm('确定要批量翻译吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				})
					.then(() => {
						this.$message({
							type: 'success',
							message: '批量成功!',
						})
					})
					.catch(() => {
						this.$message({
							type: 'info',
							message: '已取消批量',
						})
					})
			}
		},
		on_batch_select(val) {
			sessionStorage.setItem('batch_select1', JSON.stringify(val))
			// console.log(val);
			var newarr = []
			this.piece = val.length
			for (var i = 0; i < val.length; i++) {
				newarr.push(val[i].id)
				// console.log(newarr);
			}
			// console.log(newarr);
			this.batch_select = newarr
			// this.batch_select = val;
			// console.log(this.batch_select);
		},
		Testing() {
			if (this.piece == 0) {
				this.$alert('请至少勾选一件产品！', '提示', {
					confirmButtonText: '确定',
				})
			} else {
				this.$confirm('确定要批量检测吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				})
					.then(() => {
						this.$message({
							type: 'success',
							message: '检测成功!',
						})
					})
					.catch(() => {
						this.$message({
							type: 'info',
							message: '已取消检测',
						})
					})
			}
		},
		style() {
			return 'text-align: center;'
		},
		del() {
			var that = this
			if (this.piece == 0) {
				this.$alert('请至少勾选一件产品！', '提示', {
					confirmButtonText: '确定',
				})
			} else {
				this.$confirm('此操作将永久删除该产品, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				})
					.then(() => {
						ajaxPost(
							Baseurl + 'productController/deleteProductById',
							{
								ids: that.batch_select,
							}
						).then((res) => {
							console.log(res)
							if (res.data.code == 200) {
								that.$message({
									type: 'success',
									message: '删除成功!',
								})
								that.get_table_data()
								this.chatype = false
							}
						})
					})
					.catch(() => {
						this.$message({
							type: 'info',
							message: '已取消删除',
						})
					})
			}
		},
		Choiceproduct(val) {
			this.summarylist.forEach((ele) => {
				if (val) {
					this.arr.push(ele.id)

					ele.chatype = true
					this.piece = this.summarylist.length
				} else {
					ele.chatype = false
					this.piece = '0'
				}
			})
			// 批量删除
			console.log(this.arr)
		},
		commodityFrameConfirm(data) {
			const API = Baseurl + 'productController/batchUpdateProduct'

			ajaxPost(API, data).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.$refs.CommodityFrame.close()
					this.get_table_data()
					this.$message.success('操作成功')
				} else if (code === 500) {
					this.$refs.CommodityFrame.loadingStatus = false
					this.$message.warning(data)
				} else {
					this.$refs.CommodityFrame.loadingStatus = false
					this.$message.warning('操作有误')
				}
			})
		},
		endDate(val) {
			console.log(val)
			var d = new Date(val)
			var datetime =
				d.getFullYear() +
				'-' +
				(d.getMonth() + 1) +
				'-' +
				d.getDate() +
				' 23:59:59'
			this.selectForm.endTime = datetime
		},
	},
}
</script>

<style lang="scss">
.Release {
	width: 98%;
	// background: #F7F7F7;
	padding-bottom: 72px;

	.summary_bag {
		width: 98%;
		margin: auto;

		.summary_complete_bag {
			overflow: hidden;

			.summary_complete {
				overflow: hidden;
				padding: 10px 0;
				border-bottom: 1px #eee solid;

				div {
					padding: 0 10px;
					height: 30px;
					border: #2c8dff 1px solid;
					line-height: 30px;
					text-align: center;
					color: #2c8dff;
					float: left;
					border-radius: 4px;
					cursor: pointer;
				}

				.active {
					background: #2c8dff;
					color: #fff;
				}
			}
		}

		/deep/ .summary_Date {
			width: 100%;
			height: 40px;
			line-height: 40px;

			.block {
				width: 23%;
				float: left;

				.search {
					padding: 7px 10px;
					border-radius: 4px;
					background: #2c8dff;
					color: #fff;
					margin-left: 10px;
					cursor: pointer;
				}
			}

			.el-form-item__label {
				text-align: center;
			}

			.el-date-editor.el-input,
			.el-date-editor.el-input__inner {
				width: 200px;
			}

			.custom-input.el-input {
				width: 530px;
			}
		}

		.el-card__body {
			padding: 5px 20px !important;
		}

		.condition {
			overflow: hidden;

			p {
				float: left;
				line-height: 45px;
			}

			.Choice {
				float: left;
				line-height: 45px;
				margin-left: 10px;
				cursor: pointer;

				span {
					margin-right: 5px;
					padding: 2px 10px;
					border-radius: 4px;
				}

				.activespan {
					background-color: cadetblue;
					color: white;
				}
			}

			.Choicet {
				float: left;
				line-height: 45px;
				margin-left: 10px;
			}
		}

		.summary_pagenum {
			width: 100%;
			margin-bottom: 10px;
			overflow: hidden;
			background: #f5f5f5;

			.summary_query {
				width: 20%;
				float: left;
				padding: 0 10px;
				line-height: 32px;
				letter-spacing: 1px;
				color: #585858;

				span {
					color: #2c8dff;
				}
			}

			.block {
				float: right;
			}
		}

		.summary_content {
			width: 100%;
			border: 1px solid #eee;
			overflow: hidden;

			.summary_batch {
				width: 100%;
				overflow: hidden;
				border-bottom: 1px solid #eee;

				span {
					display: block;
					float: left;
					line-height: 20px;
					margin: 10px 0px;
					padding: 0 20px;
					color: #2c8dff;
					overflow: hidden;
					border-left: 1px #2c8dff solid;
				}

				span:nth-child(1) {
					color: #000;
					border-left: 0px;
				}
			}
		}

		.summary_list_top {
			width: 98%;
			margin: auto;
			overflow: hidden;
			border-bottom: 1px solid #eee;

			td {
				width: 230px;
				line-height: 40px;
			}
		}

		.summary_list {
			.scope_img {
				width: 55px;
				height: 55px;
				margin: 0 auto;

				img {
					width: 100%;
					height: 100%;
				}
			}

			.oper {
				color: #2c8dff;
				margin-right: 10px;
				cursor: pointer;
			}
		}

		.summary_pagenum_block {
			width: 1789px;
			padding: 20px;
			position: fixed;
			right: 0;
			bottom: 0;
			background: #fff;
			z-index: 999;

			.el-pagination {
				display: flex;
				justify-content: center;
			}
		}
	}
}

.prduct_img {
	width: 500px;
	height: 500px;
}

.jc-sb {
	display: flex;
	justify-content: space-between;
}

.select-css {
	border: 1px solid #c1c1c1;
	padding: 5px;
	border-radius: 5px;
}
</style>
